import type { CSSProperties } from 'react';

export const EM_DASH = '—';
export const COLOR_ANTD_RED_6 = '#f5222d';
export const SPACE_ITEM_WIDTH_100P_STYLES = { item: { width: '100%' } as CSSProperties };

// Sync with :root --header-height in styles.css
export const NAVBAR_HEIGHT = 64;

export const BREAD_CRUMB_HEIGHT = 48;
